// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__6Oxa8","description":"NotFoundBlock_description__yliyI"};